/* eslint-disable */
export default {
  businessUnit: 1,
  region: 1,
  language: 'UK',
  BRAND: (window.ctsautoconf && window.ctsautoconf.BRAND) ? window.ctsautoconf.BRAND : 'igt',
  priceFormat: 'US',
  loginRedirectPage: 'sports',
  liveBettingDataSourceType: '', // - PULL - use kansas; leave it empty for auto switch push/pull
  environmentName: process.env.NODE_ENV, // environment name
  contentServerHostname: ((window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX ? window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX : '//') + (window.ctsautoconf.CONTENT_SERVER_HOSTNAME ? window.ctsautoconf.CONTENT_SERVER_HOSTNAME : window.location.hostname)),
  webPushServiceHostname: (window.ctsautoconf && window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME ? window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME : process.env.WEBPUSH_SERVICE_HOSTNAME).replace(/:\s*$/, '') || '',
  portPerEnvironment: window.ctsautoconf && window.ctsautoconf.portPerEnvironment ? window.ctsautoconf.portPerEnvironment : {
    'default': '',
    'lbcts.webteam.beg.finsoft.com': '',
    'www.e1.ppbf.qa.beg.finsoft.com': ':4443',
    'cts.webteam.beg.finsoft.com': ':9090',
    'perf.cts.webteam.beg.finsoft.com': ':9090'
  },
  dateFormats: {
    longDate: 'MM/DD/YYYY',
    shortDate: 'M/D/YY',
    longDateTime: 'MM/DD/YYYY h:mmA',
    longDateTimePlusSecondsAmPm: 'MMMM Do YYYY, h:mm:ss a',
    longTime: 'h:mmA',
    dayAndMonth: 'DD MMMM',
    /**
     * In which locale dates/times are on website. BCP 47 language tag - https://tools.ietf.org/html/rfc5646
     * @type {string}
     */
    localeLang: 'en-US',
    /**
     * timezone in which to display/use times on website
     * @type {string}
     */
    localeTimezone: 'America/New_York',
    /**
     * timezone offsets from UTC in seconds (for standard and summer/dst time). Used only in fallback methods for time conversion. Should match localeTimezone
     */
    localeTimezoneOffset: { diffStd: -18000, diffDst: -14400 }
  },
  pageMeta: {
    eventPage: {
      title: 'Pre-Match Betting | ' + (window.ctsautoconf && window.ctsautoconf.BRAND ? window.ctsautoconf.BRAND.name : process.env.BRAND.name) + ' Sportsbook',
      description: '' + (window.ctsautoconf && window.ctsautoconf.BRAND ? window.ctsautoconf.BRAND.name : process.env.BRAND.name) + ' sportsbook offers players a unique online gaming experience with sports betting, online casino and much more.'
    },
    sportsLivePage: {
      title: 'Live In-Play Betting | ' + (window.ctsautoconf && window.ctsautoconf.BRAND ? window.ctsautoconf.BRAND.name : process.env.BRAND.name) + ' Sportsbook',
      description: '' + (window.ctsautoconf && window.ctsautoconf.BRAND ? window.ctsautoconf.BRAND.name : process.env.BRAND.name) + ' sportsbook offers players a unique online gaming experience with sports betting, online casino and much more. Our live in-play options will cover all your favorite sports, including NFL, NBA, MLB, NHL, and more.'
    }
  },
  allowInPlayTeasers: false,
  checkIsSessionAliveInterval: 180000,
  /**
   * Automated configuration values - uses package variables with override via static/app-conf.js
   */
  autoconf: {
    CONTENT_SERVER_HOSTNAME: window.ctsautoconf && window.ctsautoconf.CONTENT_SERVER_HOSTNAME ? window.ctsautoconf.CONTENT_SERVER_HOSTNAME : process.env.CONTENT_SERVER_HOSTNAME,
    CONTENT_SERVER_HOSTNAME_PREFIX: window.ctsautoconf && window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX ? window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX : process.env.CONTENT_SERVER_HOSTNAME_PREFIX,
    WEB_SERVER_HOSTNAME: window.ctsautoconf && ((!window.ctsautoconf.WEB_SERVER_HOSTNAME || window.ctsautoconf.WEB_SERVER_HOSTNAME.indexOf('//') === -1 ? '//' : '') + (window.ctsautoconf.WEB_SERVER_HOSTNAME ||
      (window.location.hostname + ( window.location.port != '' ?  (window.location.port != '80' ? ':' + window.location.port : '') : '')))),
    WALLET_URL: window.ctsautoconf && window.ctsautoconf.WALLET_URL ? window.ctsautoconf.WALLET_URL : process.env.WALLET_URL,
    GEOCOMPLY_URL: window.ctsautoconf && window.ctsautoconf.GEOCOMPLY_URL ? window.ctsautoconf.GEOCOMPLY_URL : process.env.GEOCOMPLY_URL,
    WEBPUSH_SERVICE_HOSTNAME: window.ctsautoconf && window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME ? window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME : process.env.WEBPUSH_SERVICE_HOSTNAME,
    STATE: window.ctsautoconf && window.ctsautoconf.STATE ? window.ctsautoconf.STATE : process.env.STATE,
    BUYBACK_REFRESH_INTERVAL: window.ctsautoconf && window.ctsautoconf.BUYBACK_REFRESH_INTERVAL ? window.ctsautoconf.BUYBACK_REFRESH_INTERVAL : 0,
    EXTERNAL_WALLET_PROVIDER: window.ctsautoconf && window.ctsautoconf.EXTERNAL_WALLET_PROVIDER,
    PERIODICAL_BALANCE_REFRESH_INTERVAL: window.ctsautoconf && window.ctsautoconf.PERIODICAL_BALANCE_REFRESH_INTERVAL,
    USER_INACTIVITY_LOGOUT_INTERVAL: window.ctsautoconf && window.ctsautoconf.USER_INACTIVITY_LOGOUT_INTERVAL,
    APP_DOWNLOAD_ANDROID: window.ctsautoconf && window.ctsautoconf.APP_DOWNLOAD_ANDROID,
    APP_DOWNLOAD_IOS: window.ctsautoconf && window.ctsautoconf.APP_DOWNLOAD_IOS
  }
}



// WEBPACK FOOTER //
// ./src/config/app.js